<template>
    <b-modal :id="id"
             ref="changePasswordModal"
             centered
             title="Change Password">
        <template slot="modal-footer">
            <b-button variant="secondary" @click="$refs.changePasswordModal.hide()">
                CANCEL
            </b-button>
            <pb-btn :busy="submitProcessing" variant="primary" @click.native="onSubmit">
                CONFIRM
            </pb-btn>
        </template>
        <b-form>
            <b-row class="my-2" v-if="submitError">
                <b-col>
                    <b-alert variant="danger" show>{{submitError}}</b-alert>
                </b-col>
            </b-row>
            <b-row class="my-2">
                <b-col>
                    <label for="currentPassword">Current Password:</label>
                    <b-form-input
                            class="secondary"
                            id="currentPassword"
                            name="currentPassword"
                            type="password"
                            placeholder="Current Password"
                            v-model.trim="formData.currentPassword"
                            v-validate="'required'"
                            :state="validateState('currentPassword')"
                    ></b-form-input>
                </b-col>
            </b-row>
            <b-row class="my-2">
                <b-col>
                    <label for="newPassword">New Password:</label>
                    <b-form-input
                            class="secondary"
                            id="newPassword"
                            name="newPassword"
                            type="password"
                            placeholder="New Password"
                            ref="newPassword"
                            v-model.trim="formData.newPassword"
                            v-validate="'required'"
                            :state="validateState('newPassword')"
                    ></b-form-input>
                </b-col>
            </b-row>
            <b-row class="my-2">
                <b-col>
                    <label for="confirmPassword">Confirm New Password:</label>
                    <b-form-input
                            class="secondary"
                            id="confirmPassword"
                            name="confirmPassword"
                            type="password"
                            placeholder="Confirm Password"
                            data-vv-as="newPassword"
                            v-model.trim="formData.confirmPassword"
                            v-validate="'required|confirmed:newPassword'"
                            :state="validateState('confirmPassword')"
                    ></b-form-input>
                </b-col>
            </b-row>
        </b-form>
    </b-modal>
</template>

<script>
    // @ is an alias to /src

    import {mapState} from "vuex";
    import UserApi from "@shared/_api/user";

    export default {
        name: 'pb-change-password',
        props: {
            id: String
        },
        data() {
            return {
                submitProcessing: false,
                submitError: null,
                formData: {
                    currentPassword: null,
                    newPassword: null,
                    confirmPassword: null,
                }
            }
        },
        computed: {
            ...mapState("account", ['user'])
        },
        methods: {
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            },
            onSubmit(bvModalEvt) {
                bvModalEvt.preventDefault();

                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.submitProcessing = true;
                        UserApi.changePassword(this.formData.newPassword, this.formData.currentPassword).then(() => {
                            this.$bvToast.toast(`Password successfully changed.`, {
                                toaster: "b-toaster-top-center",
                                solid: true,
                                noCloseButton: true,
                                variant: 'success',
                                appendToast: false
                            })
                            this.$nextTick(() => {
                                this.$refs.changePasswordModal.hide();
                            })
                        }).catch(err => {
                            if (err.errorCode === 'WRONG_CREDENTIALS') {
                                this.submitError = "Wrong Password.";
                            } else {
                                this.submitError = "An error occured. Please contact our customer support.";
                            }
                        }).finally(() => {
                            this.submitProcessing = false;
                        });
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>